export type InternalCodeKind =
  'DocumentType' | 'EquipmentType' | 'InspectionSite' | 'ChecklistTemplate' | 'ImportProfile';

const PREFIX: Record<InternalCodeKind, string> = {
  DocumentType: 'DOC-',
  EquipmentType: 'EQ-',
  InspectionSite: 'SITE-',
  ChecklistTemplate: 'TPL-',
  ImportProfile: 'IMP-',
};

/** Internal stable code for API bodies — never entered by ordinary users. */
export function generateInternalCode(kind: InternalCodeKind): string {
  const uuid = crypto.randomUUID().replace(/-/g, '').toUpperCase();
  return `${PREFIX[kind]}${uuid}`;
}

export function isGeneratedInternalCode(kind: InternalCodeKind, code: string): boolean {
  const prefix = PREFIX[kind];
  if (!code.startsWith(prefix)) {
    return false;
  }
  const rest = code.slice(prefix.length);
  return rest.length > 0 && /^[0-9A-F]+$/i.test(rest);
}
